/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Mark_SeenInputs */

const vi_whats_new_mark_seen = /** @type {(inputs: Whats_New_Mark_SeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xem`)
};

/**

* @param {Whats_New_Mark_SeenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_mark_seen = /** @type {((inputs?: Whats_New_Mark_SeenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Mark_SeenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_mark_seen(inputs)
});